import { useTranslation } from 'react-i18next';
import { NotificationContentRead } from './notificationContent/NotificationContentRead';
import { NotificationContentWrite } from './notificationContent/NotificationContentWrite';

const NotificationBody = ({ textContent, onChange, canEdit }) => {
  const { t: translator } = useTranslation();

  if (canEdit) {
    return (
      <NotificationContentWrite
        textContent={textContent}
        onChange={onChange}
        header={translator('notificationContent.body')}
        ariaLabel={translator('ariaLabel.notificationBodyWrite')}
        multiline={true}
        autoAdjustHeight={true}
        styles={{ field: { minHeight: '250px', maxHeight: '500px' } }}
      />
    );
  }
  return (
    <NotificationContentRead
      textContent={textContent}
      header={translator('notificationContent.body')}
      ariaLabel={translator('ariaLabel.notificationBodyRead')}
    />
  );
};

export { NotificationBody };
